export const US_ZIP_FORMAT = /^\d{5}(?:[-\s]\d{4})?$/;
export const CA_ZIP_FORMAT =
  /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]\s{0,1}[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i;

export const SSN_FORMAT = /^\d{3}-\d{2}-\d{4}$/;

export const PERMALINK_FORMAT = /^(\w|-)*$/;
